import { ProductsListColumnKeys } from '../declarations/productsList/productsList';
import { Product } from '../typings/products';

export const routeToKeyMap = {
    [ProductsListColumnKeys.PRODUCT_NAME]: (item: Product): string =>
        item.productName,
    [ProductsListColumnKeys.ID]: (item: Product): string => item.id
};
